// extracted by mini-css-extract-plugin
export default {"scope":"c+qTg","pages":"gmAs8","more":"aMFLx","limit":"NqilV","label":"tSfkc"};